import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_BASE_URL } from '../config';
import ImageInput from './ImageInput';

function slugify(s) {
  return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

export default function SpecialtyEditor({ specialty, onDone, onCancel }) {
  const { authenticatedFetch } = useAuth();
  const [form, setForm] = useState(() => specialty ? {
    id: specialty.id,
    name: specialty.name,
    slug: specialty.slug,
    description: specialty.description || '',
    image: specialty.image || '',
    durationMinutes: specialty.durationMinutes ?? 60,
    price: specialty.price != null ? String(specialty.price) : '',
    published: !!specialty.published,
    sortOrder: specialty.sortOrder || 0,
  } : {
    name: '',
    slug: '',
    description: '',
    image: '',
    durationMinutes: 60,
    price: '',
    published: true,
    sortOrder: 0,
  });
  const [saving, setSaving] = useState(false);

  function update(field, value) { setForm((f) => ({ ...f, [field]: value })); }

  async function onSave(e) {
    e.preventDefault();
    setSaving(true);
    const slug = form.slug || slugify(form.name);
    const body = {
      name: form.name,
      slug,
      description: form.description,
      image: form.image || null,
      durationMinutes: Number(form.durationMinutes) || 60,
      price: Number(form.price) || 0,
      published: form.published,
      sortOrder: Number(form.sortOrder) || 0,
    };
    const url = form.id ? `${API_BASE_URL}/api/specialties/${form.id}` : `${API_BASE_URL}/api/specialties`;
    const method = form.id ? 'PUT' : 'POST';
    const res = await authenticatedFetch(url, {
      method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    });
    setSaving(false);
    if (!res.ok) { const err = await res.json().catch(() => ({})); alert(err.error || 'Save failed'); return; }
    onDone();
  }

  return (
    <form className="specialty-editor" onSubmit={onSave}>
      <h2>{form.id ? 'Edit Specialty' : 'New Specialty'}</h2>
      <label>Name <input value={form.name} onChange={(e) => update('name', e.target.value)} required /></label>
      <label>Slug <input value={form.slug} onChange={(e) => update('slug', e.target.value)} placeholder="auto from name" /></label>
      <label>Description <textarea rows={6} value={form.description} onChange={(e) => update('description', e.target.value)} /></label>
      <label>Duration (minutes) <input type="number" min="1" value={form.durationMinutes} onChange={(e) => update('durationMinutes', e.target.value)} required /></label>
      <label>Price ($) <input type="number" step="0.01" min="0" value={form.price} onChange={(e) => update('price', e.target.value)} placeholder="85.00" required /></label>
      <ImageInput label="Image" value={form.image} onChange={(v) => update('image', v)} />
      <label><input type="checkbox" checked={form.published} onChange={(e) => update('published', e.target.checked)} /> Published</label>
      <label>Sort order <input type="number" value={form.sortOrder} onChange={(e) => update('sortOrder', e.target.value)} /></label>

      <div className="editor-actions">
        <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
        <button type="button" className="btn-secondary" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
